import { useEffect, useRef } from 'react'

import { noop } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useImageCardStore } from '../Store/hooks/useStore'

export const useUpdateImageSize = () => {
  const flagRef = useRef(false)
  const { ossUrl, setOriginalSize } = useImageCardStore(state =>
    pick(state, ['ossUrl', 'setOriginalSize'])
  )

  useEffect(() => {
    if (!ossUrl || flagRef.current) {
      return
    }
    const img = document.createElement('img')
    img.src = ossUrl
    img.onerror = noop
    img.onload = event => {
      const { naturalHeight, naturalWidth } = event.target as HTMLImageElement
      setOriginalSize({
        width: naturalWidth,
        height: naturalHeight
      })
      flagRef.current = true
    }
  }, [ossUrl, setOriginalSize])
}
